import { registerWorkflowProduct } from "src/views/products/workflow/registry";
import { getProposalGenerationDialogueData } from "./services/ProposalGenerationServices";

// Every route this product builds hangs off it, so the descriptor and the URL
// builder read the same constant rather than repeating the literal.
const BASE_PATH = "/proposal-generation";

/**
 * PG's workflow-product descriptor. Every value is the literal PG shipped
 * with — this file changes WHERE the strings live, never what they are
 * (streamKey and testIdPrefix are frozen contracts; see the type docs).
 */
export const PROPOSAL_GENERATION_PRODUCT = registerWorkflowProduct({
  productKey: "proposal-generation",
  licenseModule: "proposal-generation",
  displayName: "Proposal Generation",
  basePath: BASE_PATH,
  streamKey: "proposal-generation",
  testIdPrefix: "propgen",
  // The initial-mode splash creates a review-report dialogue, so the review
  // slot's resolution (binding -> proposal_generation_review_persona ->
  // legacy proposal_generation_persona) is what will run it.
  leadSlotKey: "review",
  buildChatUrlForDialogue: (queryClient) => async (dialogueId: number) => {
    try {
      // Use queryClient.fetchQuery to leverage React Query caching
      const data = await queryClient.fetchQuery(
        ["proposalGenerationRun", dialogueId],
        () => getProposalGenerationDialogueData(dialogueId),
        { staleTime: 5 * 60 * 1000 }, // Cache for 5 minutes
      );
      const runId = data.proposal_generation_run_id;
      if (runId) {
        return `${BASE_PATH}/chat/${runId}/${dialogueId}`;
      }
    } catch (error) {
      console.error("ProposalGeneration: Failed to fetch run ID:", error);
    }
    // Fallback: if no run ID available, redirect to splash page
    console.warn(
      "ProposalGeneration: Dialogue missing proposal_generation_run_id, redirecting to splash",
      dialogueId,
    );
    return BASE_PATH;
  },
});
